/** Approved / live listing */
export const PROPERTY_STATUS_APPROVED = 2;
/** Sold out — hidden from browse; visible by direct ID lookup */
export const PROPERTY_STATUS_SOLD_OUT = 4;

export const isSoldOut = (property) => Number(property?.status_id) === PROPERTY_STATUS_SOLD_OUT;

/** Active listing = approved (status_id 2). */
export const isListingActive = (property) => Number(property?.status_id) === PROPERTY_STATUS_APPROVED;

export const canPerformListingActions = (property) => isListingActive(property);

export const LISTING_INACTIVE_MSG = 'This listing is not active. Booking, enquiry, and call are unavailable.';

export const SOLD_OUT_MSG = 'This property has been sold out. Booking, enquiry, and contact are unavailable.';
